import DocumentRedirectPage from './document-redirect-page'
export default DocumentRedirectPage;